import { render, staticRenderFns } from "./FirstSidebarItem.vue?vue&type=template&id=31cc0508&scoped=true"
import script from "./FirstSidebarItem.vue?vue&type=script&lang=js"
export * from "./FirstSidebarItem.vue?vue&type=script&lang=js"
import style0 from "./FirstSidebarItem.vue?vue&type=style&index=0&id=31cc0508&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cc0508",
  null
  
)

export default component.exports